/* eslint-disable import/no-anonymous-default-export */

import dictionary from "../util/dictionary";
import apiCall from "./apiCall";

 const apiHost=dictionary.apiHost;
const ACCESS_TOKEN = localStorage.getItem('yexp@user');

export default {
   
    async listAssetAccounts()
    {

        let data={
            "source":"Web",
        }

        let response = await apiCall('asset/accounts/list', data);
        return response;
       
    },

    async listPaymentAccounts()
    {

        let data={
            "source":"Web",
        }
        try{
            let response= await fetch(apiHost + 'income/payment-accounts/list',
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Accept': 'application/json', 
                    'Content-Type': 'application/json',
                    'Source': 'Admin'
                },
                body:JSON.stringify(data),
            });

                let result= await response.json();

                return result;
            }catch(error)
            {
                let connError={'status':'conn', 'details':['Contacting server....']}
                return connError;
            }

    },
    async addAsset(paymentAccount, targetAccount, amount, transactionDate, description, payee, transactionRef, tag)
    {

        let data={
            "trail_account":paymentAccount,
            "target_account":targetAccount,
            "amount":amount,
            "transaction_date":transactionDate,
            "description":description,
            "payee":payee,
            "transaction_reference":transactionRef,
            "tag":tag
        }
        
        let response = await apiCall("asset/add", data);
        return response;

    },

    async getAssetBalance()
    {

        let data={
            "source":"Web",
        }
        try{
            let response= await fetch(apiHost + 'asset/balance',
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Accept': 'application/json', 
                    'Content-Type': 'application/json',
                    'Source': 'Admin'
                },
                body:JSON.stringify(data),
            });

                let result= await response.json();

                return result;
            }catch(error)
            {
                let connError={'status':'conn', 'details':['Contacting server....']}
                return connError;
            }

    },

    async listAssetBalances()
    {

        let data={
            "source":"Web",
        }
        try{
            let response= await fetch(apiHost + 'asset/balances/list',
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Accept': 'application/json', 
                    'Content-Type': 'application/json',
                    'Source': 'Admin'
                },
                body:JSON.stringify(data),
            });

                let result= await response.json();

                return result;
            }catch(error)
            {
                let connError={'status':'conn', 'details':['Contacting server....']}
                return connError;
            }

    },

    async addContra(paymentAccount, targetAccount, amount, transactionDate, description, payee, transactionRef, tag)
    {

        let data={
            "trail_account":paymentAccount,
            "target_account":targetAccount,
            "amount":amount,
            "transaction_date":transactionDate,
            "description":description,
            "payee":payee,
            "transaction_reference":transactionRef,
            "tag":tag
        }

        let response = await apiCall('asset/contra/add', data);
        return response;

    },

    async fetchAccountsReceivable()
    {

        let data={
            "source":"Web",
        }
       
        let response = await apiCall("receivable/accounts/list", data);
        return response;

    },

    async appreciateValue(paymentAccount, targetAccount, amount, transactionDate, description, payee, transactionRef, tag)
    {

        let data={
            "trail_account":paymentAccount,
            "target_account":targetAccount,
            "amount":amount,
            "transaction_date":transactionDate,
            "description":description,
            "payee":payee,
            "transaction_reference":transactionRef,
            "tag":tag
        }

        const response= await apiCall("asset/value/appreciate", data);
        return response;

    },


    async depreciateValue(paymentAccount, targetAccount, amount, transactionDate, description, payee, transactionRef, tag)
    {

        let data={
            "trail_account":paymentAccount,
            "target_account":targetAccount,
            "amount":amount,
            "transaction_date":transactionDate,
            "description":description,
            "payee":payee,
            "transaction_reference":transactionRef,
            "tag":tag
        }

        const response = await apiCall("asset/value/depreciate", data);
        return response;

    },
    
    

} 